module.exports = __webpack_public_path__ + "img/video.3989ca8c.svg";